import Swiper, { Navigation } from 'swiper';
import 'swiper/css';

export default class TopicsDetailSlider {
  constructor(elem, opts) {
    this.elm = elem
    this.breakpoint = 768
    this.topicsDetailSliderFlg = false

    this.eventBinds()
  }

  eventBinds() {
    const _this = this
    if(!_this.isPC()){
      this.topicsDetailSliderFlg = true
      this.addTopicsDetailSliderControl()
    }

    window.addEventListener('resize', ()=> {
      if(!_this.isPC()){
        if(!_this.topicsDetailSliderFlg){
          _this.topicsDetailSliderFlg = true
          _this.addTopicsDetailSliderControl()
        }
      }else{
        if(_this.topicsDetailSliderFlg){
          _this.topicsDetailSliderFlg = false
          _this.removeTopicsDetailSliderControl()
        }
      }
    })
  }

  isPC() {
    if (window.innerWidth >= this.breakpoint) {
      return true
    } else {
      return false
    }
  }

  addTopicsDetailSliderControl(){
    this.topicsDetailSlider = new Swiper(".swiper", {
      modules: [ Navigation ],
      slidesPerView: 1,
      // spaceBetween: 35,
      freeMode: true,
      centeredSlides: false,
      navigation: {
        nextEl: '.swiper__topics__reccomend__btn.is-next',
        prevEl: '.swiper__topics__reccomend__btn.is-prev',
      },
    });
  }

  removeTopicsDetailSliderControl(){
    this.topicsDetailSlider.destroy();
    this.topicsDetailSlider = undefined;
  }
}